module.exports = __webpack_public_path__ + "static/media/nz.6fd4979f.svg";